import React from 'react';
import autoBind from 'react-autobind';
import Localization from "../Localization.jsx";
import { Modal, Stack, Group, TextInput, Button, Text } from '@mantine/core';

class ChangePasswordDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    this.state = {
      open: false,
      oldPassword: "",
      newPassword: "",
      confirmPassword: ""
    };
    autoBind(this);
  }

  updatePassword() {
    if (this.validateInput()) {
      let requestObj = {
        "user_id": this.props.root.getMyUserId(),
        "old_password": this.state.oldPassword.trim(),
        "new_password": this.state.newPassword.trim(),
      }
      this.props.root.refs.API.request("user_update_password", requestObj, this.updatePasswordOK, this.updatePasswordFail);
    }
  }

  updatePasswordOK(res) {
    this.handleClose();
  }

  updatePasswordFail(err) {
    console.log("update password failed");
    this.props.root.addNotification(Localization.strings.PASSWORD_UPDATE_FAIL, false);
  }

  handleClose() {
    // Clear the entered passwords so they don't linger in state / the inputs across opens.
    this.setState({
      open: false,
      oldPassword: "",
      newPassword: "",
      confirmPassword: ""
    });
  }

  oldPasswordChanged(event) {
    this.setState({
      oldPassword: event.target.value
    });
  }

  newPasswordChanged(event) {
    this.setState({
      newPassword: event.target.value
    });
  }

  confirmPasswordChanged(event) {
    this.setState({
      confirmPassword: event.target.value
    });
  }

  validateInput() {
    let result = true;
    let password = this.state.newPassword.trim();
    let illegalChars = /[\W_]/;
    let errorMessage = "";

    if (this.state.oldPassword.trim() === "" || this.state.newPassword.trim() === "" || this.state.confirmPassword.trim() === "") {
      result = false;
      errorMessage = Localization.strings.PASSWORD_REQUIREMENT_5;
    } else if (this.state.newPassword.trim() !== this.state.confirmPassword.trim()) {
      result = false;
      errorMessage = Localization.strings.PASSWORD_REQUIREMENT_0;
    } else if (illegalChars.test(password)) {
      result = false;
      errorMessage = Localization.strings.PASSWORD_REQUIREMENT_1;
    } else if (password.search(/[a-zA-Z]+/) === -1 || password.search(/[0-9]+/) === -1) {
      result = false;
      errorMessage = Localization.strings.PASSWORD_REQUIREMENT_2;
    } else if (password.length < 6) {
      result = false;
      errorMessage = Localization.strings.PASSWORD_REQUIREMENT_3;
    } else if (password.length > 30) {
      result = false;
      errorMessage = Localization.strings.PASSWORD_REQUIREMENT_4;
    }

    if (errorMessage !== "") {
      this.props.root.addNotification(errorMessage, false);
    }

    return result;
  }

  render() {
    return (
      <Modal
        opened={this.state.open}
        onClose={this.handleClose}
        title={<Text fw={600}>{Localization.strings.CHANGE_PASSWORD}</Text>}
        size="md"
        centered
        zIndex={2000}
      >
        <Stack gap="md">
          <TextInput
            type="password"
            label={Localization.strings.OLD_PASSWORD}
            description={Localization.strings.OLD_PASSWORD_HELPER}
            onChange={this.oldPasswordChanged}
          />
          <TextInput
            type="password"
            label={Localization.strings.NEW_PASSWORD}
            description={Localization.strings.NEW_PASSWORD_HELPER}
            onChange={this.newPasswordChanged}
          />
          <TextInput
            type="password"
            label={Localization.strings.RE_ENTER_NEW_PASSWORD}
            description={Localization.strings.CONFIRM_PASSWORD_HELPER}
            onChange={this.confirmPasswordChanged}
          />
          <Group justify="flex-end" mt="sm">
            <Button variant="default" onClick={this.handleClose}>
              {Localization.strings.CANCEL}
            </Button>
            <Button onClick={this.updatePassword}>
              {Localization.strings.UPDATE_PASSWORD}
            </Button>
          </Group>
        </Stack>
      </Modal>
    )
  }
}

export default ChangePasswordDialog;
